import React from "react";
import popupStore from "../../../store/popupStore";
import {ListAddressSeller} from "../../StoreFormAddress/ListAddressSeller";
import appStore from "../../../store/appStore";
import {isMobile} from "react-device-detect";
import {text} from "../../../constants/text";

const AddressInfo = ({
                         addressShip,
                         noted,
                         name,
                         phoneNumber,
                         addressPickup
                     }) => {
    const {setPopup, setPopupMobile} = popupStore() || {}
    const {setAnimate} = appStore()
    const handleChangeAddress = () => {
        if (isMobile) {
            setAnimate({direction: "left"})
            setPopupMobile({
                isOpenMobile: true,
                data: {
                    height: "h-[78%]",
                    top: "top-[22%]",
                    children: <ListAddressSeller
                        addressPickup={addressPickup}
                    />
                }
            })
        } else {
            setAnimate({direction: "left"})
            setPopup({
                isOpen: true,
                data: {
                    buttonCloseClass: 'top-6 right-6',
                    customContent: () => <ListAddressSeller
                        addressPickup={addressPickup}
                    />
                }
            })
        }
    }

    return (
        <div className="bg-white rounded-[10px] p-4 space-y-1 md:space-y-2">
            <div className="md:flex items-center md:space-x-1">
                <div>{`Địa chỉ lấy hàng `}</div>
                <div className="text-gray-400 text-xs font-normal">{` (địa chỉ nơi nhân viên giao hàng đến lấy)`}</div>
            </div>
            <div className="md:flex justify-between space-y-1 md:space-y-0">
                <div className='max-w-[113px] space-y-1'>
                    <div className="font-bold">{name}</div>
                    <div className="text-gray-600">{phoneNumber}</div>
                </div>
                <div className='max-w-[350px] space-y-1'>
                    <div className="">{addressShip}</div>
                    {noted && <div className="text-gray-500 text-xs">{`${text.notes}: ${noted}`}</div>}
                </div>
                <div className="text-[#197D55] text-sm underline cursor-pointer"
                     onClick={handleChangeAddress}>{text.changeAddress}
                </div>
            </div>
        </div>
    )
};
export default AddressInfo;